<template>
  <div class="side-tab-wrapper">
    <!-- 顶部按钮区域 -->
    <div class="top-btn-group">
      <el-button type="info" plain :disabled="!hasExportData" @click="handleExport">导出</el-button>
      <el-button type="info" plain :disabled="!selectedItemId" @click="handleUpload">上传</el-button>
      <el-button type="info" plain :disabled="!selectedItemId" @click="viewLabel">查看</el-button>
      <el-button type="info" plain :disabled="!selectedItemId" @click="editLabel">修改</el-button>
      <el-button type="primary"  @click="addLabel">添加标签</el-button>
      <el-button type="danger" :disabled="!selectedItemId" @click="deleteLabel">删除标签</el-button>
    </div>
    
    <!-- 添加标签弹窗 -->
    <ButtonDialog 
      ref="buttonDialog" 
      :modelValue="dialogFormVisible" 
      :dialogTitle="dialogTitle" 
      :dialogWidth="dialogWidth" 
      @update:modelValue="dialogFormVisible = $event" 
      @confirm="submitForm">
      <slot>
        <el-form label-position="right" label-width="100px" :model="formLabelAlign" :rules="rules" ref="ruleForm">
          <el-form-item label="标签名称" prop="tagName">
            <el-input v-model="formLabelAlign.tagName" placeholder="请输入标签名称" clearable></el-input>
          </el-form-item>
        </el-form>
      </slot>
    </ButtonDialog>
    
    <!-- 查看标签详情弹窗 - 使用Tab切换形式 -->
    <LabelDetailTabsDialog
      ref="labelDetailDialog"
      :visible.sync="viewDialogVisible"
      :title="viewDialogTitle"
      :label-id="selectedItemId"
      :dict-item-id="currentDictItemId"
      @view-wave="handleViewWave"
      @migrate="handleMigrate"
      @batch-migrate="handleBatchMigrate"
      @close="handleLabelDetailDialogClose">
    </LabelDetailTabsDialog>

    
    <!-- 波形查看弹窗 -->
    <wave-dialog 
      :visible.sync="waveDialogVisible" 
      :record-id="currentWaveId"
      @close="handleWaveClose">
    </wave-dialog>
    
    <!-- 迁移标签弹窗 -->
    <el-dialog v-if="migrateDialogVisible" title="迁移标签" :visible.sync="migrateDialogVisible" width="30%"
      :before-close="handleMigrateClose" :close-on-click-modal="true">
      <div class="fault_box">
        <LabelAssociate 
          :recordIds="migrateRecordIds" 
          :operationType="currentActiveTab === 'import' ? 'relate' : 'migrate'"
          @close="handleMigrateClose" 
          @submit="handleMigrateSubmit"/>
      </div>
    </el-dialog>
    
    <!-- 上传弹窗 -->
    <ButtonDialog 
      ref="uploadButtonDialog" 
      :modelValue="uploadDialogVisible" 
      dialogTitle="上传" 
      dialogWidth="620px" 
      :onlyCloseBtn="uploadProgressVisible"
      :confirmDisabled="!canUploadSubmit"
      @update:modelValue="uploadDialogVisible = $event" 
      @confirm="handleUploadSubmit"
      @close="handleUploadDialogClose">
      <slot>
          <!-- 上传进度遮罩层 -->
        <div class="upload-dialog-content-wrapper" v-if="uploadProgressVisible">
          <div  class="upload-overlay">
            <div class="upload-overlay-content">
              <div class="upload-progress-info">
                <span class="progress-text">
                  <i v-if="uploadProgress === 100" class="el-icon-circle-check success-icon"></i>
                  <i v-else class="el-icon-loading loading-icon"></i>
                  {{ uploadProgress === 100 ? '上传处理完成！' : '正在上传处理文件...' }}
                </span>
                <span class="progress-percent">
                  <span :class="{ 'success-text': uploadProgress === 100 }">{{ uploadProgress.toFixed() }}%</span>
                </span>
              </div>
              <el-progress 
                :percentage="uploadProgress" 
                :stroke-width="8"
                :color="uploadProgress === 100 ? '#67c23a' : '#00d8c3'"
                :show-text="false">
              </el-progress>
            </div>
          </div>
        </div>
          
          <el-form v-else ref="uploadForm" label-position="right" label-width="120px" :model="uploadFormData" size="small">
          <el-form-item 
            v-for="(config, key) in uploadFormConfig" 
            :key="key"
            :prop="config.field"
            :rules="config.required ? [{ required: true, message: `请选择${config.label.replace('(个)', '')}`, trigger: 'change' }] : []">
            <template slot="label">
                {{ config.label }}
            </template>
            <!-- 单选卡片类型 -->
            <div v-if="config.type === 'radio-card'" class="custom-radio-group">
              <div 
                v-for="option in config.options" 
                :key="option.value"
                class="radio-card"
                :class="{ active: uploadFormData[config.field] === option.value }"
                @click="uploadFormData[config.field] = option.value">
                <span class="radio-number">{{ option.label }}</span>
              </div>
            </div>
            <!-- 文件上传类型 -->
            <div v-else-if="config.type === 'upload'" class="upload-section">
              <FileUpload
                ref="fileUpload"
                :file-list="fileList"
                :upload-loading="uploadLoading"
                :selected-item="getSelectedItemData()"
                :current-tab-item="getCurrentTabItemData()"
                @success="handleUploadSuccess"
                @error="handleUploadError"
                @loading="handleUploadLoading"
                @remove="handleRemove"
                @update:fileList="fileList = $event"
              />
            </div>
          </el-form-item>
        </el-form>
      </slot>
    </ButtonDialog>
    
    <!-- 导出弹窗 -->
    <ExportDialog
      :visible.sync="exportDialogVisible"
      :dataList="exportDataList"
      :pagination="exportPagination"
      :dictItemInfo="exportDictItemInfo"
      @pageChange="handleExportPageChange"
      @sizeChange="handleExportSizeChange"
      @batchExport="handleBatchExport"
      @jumpToTaskCenter="handleJumpToTaskCenter">
    </ExportDialog>
    
    <!-- 侧边菜单容器 -->
    <div class="side-menu-container">
      <!-- 搜索框 -->
      <div class="menu-search-box">
        <el-input
          v-model="searchKeyword"
          placeholder="搜索菜单..."
          prefix-icon="el-icon-search"
          clearable
          size="small"
          @input="handleSearch"
          @clear="handleSearchClear"
        >
        </el-input>
      </div>
      
      <!-- 侧边菜单（Tab 切换栏） -->
      <el-menu
        class="side-menu"
        mode="vertical"
        :default-active="activeTab"
        @select="switchTab"
      >
        <el-menu-item
          v-for="(item, idx) in filteredTabList"
          :key="item.id"
          :index="getOriginalIndex(item).toString()"
          class="custom-menu-item"
          :class="{ 'search-highlight': isHighlighted(item) }"
        >
          <div class="menu-item-content">
            <el-tooltip 
              :content="item.name" 
              placement="right"
              effect="light"
              :disabled="!isTextOverflow(item.name)"
            >
              <span class="menu-item-text" v-html="highlightText(item.name)"></span>
            </el-tooltip>
            <span class="menu-item-separator">-</span>
            <span class="menu-item-code" v-html="highlightText(item.itemCode)"></span>
          </div>
        </el-menu-item>
        
        <!-- 无搜索结果提示 -->
        <div v-if="filteredTabList.length === 0 && searchKeyword" class="no-search-result">
          <i class="el-icon-search"></i>
          <p>未找到匹配的菜单</p>
        </div>
      </el-menu>
    </div>

    <!-- 右侧内容区域 -->
    <div class="content-panel">
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-container">
        <div class="loading-spinner">
          <i class="el-icon-loading"></i>
          <p>数据加载中...</p>
        </div>
      </div>

      <!-- 无数据状态 -->
      <div v-else-if="!hasData" class="empty-container">
        <div class="empty-content">
          <i class="el-icon-document-delete"></i>
          <h3>暂无数据</h3>
          <p>当前分类下还没有标签数据</p>
          <el-button type="primary" size="small" @click="addLabel">
            <i class="el-icon-plus"></i>
            添加标签
          </el-button>
        </div>
      </div>

      <!-- 内容区域 - 动态渲染当前标签页 -->
      <div v-else>
        <!-- 当前分类标题 -->
        <h3>{{ currentTabTitle }}</h3>
        <!-- 宫格布局容器 -->
        <div class="grid-container">
          <div 
            v-for="item in currentGridData" 
            :key="item.id" 
            class="grid-item"
            :class="{ 'selected': selectedItemId === item.id }"
            @click="selectItem(item.id)"
          >
            <div class="grid-content">
              <div class="item-id">{{  item.id }}</div>
              <div class="content-item">
                <div> {{ item.tagName }} ({{ item.waveformCount }})</div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 分页组件 -->
        <div class="pagination-container" v-if="currentPageData.total > 0">
          <PageButton
            :total="currentPageData.total"
            :page-size="currentPageData.size"
            :current-page="currentPageData.current"
            @pageChange="handleCurrentChange"
            @sizeChange="handleSizeChange">
          </PageButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { waveformDictCode, waveformList, waveformAdd, waveformUpdate, waveformDelete, waveformNpyResolve, waveformView } from "@/api/waveform/manage";
import ButtonDialog from '@/components/dialog/ButtonDialog.vue'
import PageButton from '@/components/buttons/PageButton.vue'
import waveDialog from '@/view/waveform/load/components/waveDialog.vue'
import LabelAssociate from '@/components/LabelAssociate/index.vue'
import FileUpload from '@/components/FileUpload/index.vue'
import LabelDetailTabsDialog from './components/LabelDetailTabsDialog.vue'
import ExportDialog from './components/ExportDialog.vue'

export default {
    name: 'index',
    components: {
      ButtonDialog,
      PageButton,
      waveDialog,
      LabelAssociate,
      FileUpload,
      LabelDetailTabsDialog,
      ExportDialog
  },
  data() {
    return {
      // 搜索关键词
      searchKeyword: '',
      // 侧边 Tab 列表
      tabList: [],
      // 当前激活的 Tab（对应 tabList 的索引）
      activeTab: '0',
      // 选中的项目ID
      selectedItemId: null,
      // 宫格数据 - 每个标签页的内容
      gridData: {},
      // 分页数据 - 每个标签页的分页信息
      pageData: {},
      // 接口返回的数据
      apiData: null,
      // 加载状态
      loading: false,
      // 弹窗相关数据
      dialogFormVisible: false,
      dialogTitle: '',
      dialogWidth: '30%',
      formLabelAlign: {
        dictItemId: '',
        dictItemName: '',
        tagName: ''
      },
      rules: {
        tagName: [
          { required: true, message: '请输入标签名称', trigger: 'blur' }
        ]
      },
      // 查看弹框相关数据
      viewDialogVisible: false,
      viewDialogTitle: '查看标签详情',
      waveDialogVisible: false, // 波形弹窗显示状态
      currentWaveId: '', // 当前查看的波形ID
      migrateDialogVisible: false, // 迁移标签弹窗显示状态
      migrateRecordIds: [], // 需要迁移标签的ID数组
      currentActiveTab: 'migrate', // 当前激活的标签页，用于设置operationType
      uploadDialogVisible: false, // 上传参数弹窗显示状态
      uploadLoading: false, // 文件上传加载状态
      uploadingFileCount: 0, // 正在上传的文件数量
      // 上传进度条相关
      uploadProgressVisible: false, // 进度条显示状态
      uploadProgress: 0, // 上传进度百分比
      uploadProgressTimer: null, // 进度条定时器
      // 上传表单数据
      uploadFormData: {
        samplePoint: '256', // 采样点，默认256
        sampleNum: '6'    // 周波，默认6
      },
      // 文件列表
      fileList: [],
      // 上传表单配置
      uploadFormConfig: {
        samplePoint: {
          label: '采样点(个)',
          field: 'samplePoint',
          type: 'radio-card',
          required: true,
          options: [
            { label: '64', value: '64' },
            { label: '128', value: '128' },
            { label: '256', value: '256' }
          ]
        },
        sampleNum: {
          label: '周波(个)',
          field: 'sampleNum',
          type: 'radio-card',
          required: true,
          options: [
            { label: '2', value: '2' },
            { label: '3', value: '3' },
            { label: '4', value: '4' },
            { label: '5', value: '5' },
            { label: '6', value: '6' }
          ]
        },
        file: {
          label: '上传文件',
          field: 'file',
          type: 'upload',
          required: true
        }
      },
      exportDialogVisible: false
    }
  },
  computed: {
    // 过滤后的菜单列表
    filteredTabList() {
      if (!this.searchKeyword || this.searchKeyword.trim() === '') {
        return this.tabList
      }
      const keyword = this.searchKeyword.toLowerCase().trim()
      return this.tabList.filter(item => {
        return item.name.toLowerCase().includes(keyword) || 
               item.itemCode.toLowerCase().includes(keyword) ||
               item.itemName.toLowerCase().includes(keyword)
      })
    },
    // 判断当前标签页是否有数据
    hasData() {
      const currentData = this.gridData[this.activeTab]
      return currentData && currentData.length > 0
    },
    // 当前标签页的标题
    currentTabTitle() {
      const currentTab = this.tabList[parseInt(this.activeTab)]
      return currentTab ? currentTab.name.split('(')[0].trim() : ''
    },
    // 当前标签页的dictItemId
    currentDictItemId() {
      const currentTab = this.tabList[parseInt(this.activeTab)]
      return currentTab ? currentTab.id : ''
    },
    // 判断是否可以点击上传确定按钮
    canUploadSubmit() {
      // 如果正在读取文件或上传加载中，禁止点击
      if (this.uploadLoading || this.uploadingFileCount > 0) {
        return false
      }
      
      // 如果没有选择文件，禁止点击
      if (!this.fileList || this.fileList.length === 0) {
        return false
      }
      
      // 检查是否有文件正在上传（状态为uploading或ready）
      const hasUploadingFile = this.fileList.some(file => 
        file.status === 'uploading' || 
        file.status === 'ready'
      )
      if (hasUploadingFile) {
        return false
      }
      
      // 检查是否有文件上传失败（状态为fail）
      const hasFailedFile = this.fileList.some(file => file.status === 'fail')
      if (hasFailedFile) {
        return false
      }
      
      // 确保所有文件都已成功上传
      const allFilesUploaded = this.fileList.every(file => 
        file.status === 'success' || 
        (file.response && file.response.url) // 有响应URL也表示上传成功
      )
      if (!allFilesUploaded) {
        return false
      }
      
      return true
    },
    // 当前标签页的网格数据
    currentGridData() {
      return this.gridData[this.activeTab] || []
    },
    // 当前标签页的分页数据
    currentPageData() {
      return this.pageData[this.activeTab] || {
        current: 1,
        size: 20,
        total: 0,
        pages: 0
      }
    },
    // 导出数据列表 - 使用当前标签页的所有数据
    exportDataList() {
      return this.currentGridData
    },
    // 导出分页数据 - 使用当前标签页的分页信息
    exportPagination() {
      return this.currentPageData
    },
    // 导出字典项信息 - 使用当前标签页的信息
    exportDictItemInfo() {
      const currentTab = this.tabList[parseInt(this.activeTab)]
      if (!currentTab) {
        return {
          dictItemId: '',
          dictItemName: '',
          dictItemCode: ''
        }
      }
      return {
        dictItemId: currentTab.id,
        dictItemName: currentTab.itemName,
        dictItemCode: currentTab.itemCode
      }
    },
    // 是否有可导出的数据（波形数量大于0）
    hasExportData() {
      return this.currentGridData.some(item => item.waveformCount > 0)
    }
  },
  mounted() {
    this.initWaveformDictCode()
  },
  methods: {
    // 处理搜索输入
    handleSearch() {
      // 如果有搜索关键词，自动选中第一个匹配项
      if (this.searchKeyword && this.searchKeyword.trim() !== '' && this.filteredTabList.length > 0) {
        const firstMatchedItem = this.filteredTabList[0]
        const originalIndex = this.getOriginalIndex(firstMatchedItem)
        if (originalIndex !== -1) {
          this.activeTab = originalIndex.toString()
        }
      }
    },
    
    // 清除搜索
    handleSearchClear() {
      this.searchKeyword = ''
    },
    
    // 高亮文本中的搜索关键词
    highlightText(text) {
      if (!this.searchKeyword || this.searchKeyword.trim() === '') {
        return text
      }
      const keyword = this.searchKeyword.trim()
      if (!keyword) return text
      
      // 使用正则表达式进行不区分大小写的替换
      const regex = new RegExp(`(${keyword})`, 'gi')
      return text.replace(regex, '<span class="search-highlight-text" style="vertical-align: bottom;">$1</span>')
    },
    
    // 判断菜单项是否应该高亮显示
    isHighlighted(item) {
      if (!this.searchKeyword || this.searchKeyword.trim() === '') {
        return false
      }
      const keyword = this.searchKeyword.toLowerCase().trim()
      return item.name.toLowerCase().includes(keyword) || 
             item.itemCode.toLowerCase().includes(keyword) ||
             item.itemName.toLowerCase().includes(keyword)
    },
    
    // 获取菜单项在原始列表中的索引
    getOriginalIndex(item) {
      return this.tabList.findIndex(tabItem => tabItem.id === item.id)
    },
    
    // 格式化文件名（名称+时间戳，去除时间中的分隔符）
    formatFileName(row) {
      if (!row.macAddr || !row.triggerTime) return ''
      // 移除时间字符串中的分隔符（-、:、空格等）
      const cleanTime = row.triggerTime.replace(/[-:\s]/g, '')
      return `${row.macAddr}_${cleanTime}.npy`
    },
    
    async initWaveformDictCode() {
      this.loading = true
      try {
        const response = await waveformDictCode('cnnModeRecognitionType')
        this.apiData = response.data
        this.updateTabListFromApiData()
      } catch (error) {
        console.error('调用 waveformDictCode 接口失败:', error)
      } finally {
        this.loading = false
      }
    },
    // 根据接口返回数据更新侧边栏列表
    updateTabListFromApiData() {
      if (this.apiData && Array.isArray(this.apiData)) {
        this.tabList = this.apiData.map(item => ({
          id: item.id,
          name: item.itemName + ' (' + item.waveformCount + ')',
          dictItemId: item.id,
          itemName: item.itemName,
          waveformCount: item.waveformCount,
          itemCode: item.itemCode
        }))

        // 如果有数据，保持当前选中状态或默认选中第一个菜单项
        if (this.tabList.length > 0) {
          // 如果当前有选中标签页，保持选中状态；否则默认选中第一个
          const currentTabIndex = this.activeTab
          if (currentTabIndex !== null && currentTabIndex !== undefined && this.tabList[currentTabIndex]) {
            // 保持当前选中状态，重新加载数据
            this.callWaveformList(currentTabIndex)
          } else {
            // 默认选中第一个菜单项
            this.activeTab = '0'
            this.callWaveformList('0')
          }
        }
      }
    },
    // 刷新标签列表（保持当前选中状态）
    async refreshTabList() {
      this.loading = true
      try {
        const response = await waveformDictCode('cnnModeRecognitionType')
        this.apiData = response.data
        
        // 更新标签列表，但不改变当前选中状态
        if (this.apiData && Array.isArray(this.apiData)) {
          this.tabList = this.apiData.map(item => ({
            id: item.id,
            name: item.itemName + ' (' + item.waveformCount + ')',
            dictItemId: item.id,
            itemName: item.itemName,
            waveformCount: item.waveformCount,
            itemCode: item.itemCode
          }))
        }
      } catch (error) {
        console.error('刷新标签列表失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 刷新右侧内容区域数据
    async refreshRightContent() {
      // 刷新当前激活标签页的数据
      if (this.activeTab !== null && this.tabList[this.activeTab]) {
        await this.callWaveformList(this.activeTab)
      }
    },

    // 完全刷新所有数据（左侧菜单 + 右侧内容）
    async refreshAllData() {
      console.log('开始完全刷新数据...')
      
      try {
        // 先刷新左侧菜单
        await this.refreshTabList()
        console.log('左侧菜单刷新完成')
        
        // 再刷新右侧内容
        await this.refreshRightContent()
        console.log('右侧内容刷新完成')
        
        // 如果查看弹窗是打开的，也刷新弹窗数据
        if (this.viewDialogVisible && this.selectedItemId) {
          this.loadViewData()
          console.log('弹窗数据刷新完成')
        }
        
        // 如果导入标签页是打开的，也刷新导入数据
        this.refreshImportTabData()
        
        console.log('完全刷新数据完成')
      } catch (error) {
        console.error('刷新数据时出错:', error)
        this.$message.error('刷新数据时出错，请稍后重试')
      }
    },

    // 刷新导入标签页数据
    refreshImportTabData() {
      // 延迟执行，确保DOM更新完成
      this.$nextTick(() => {
        if (this.viewDialogVisible && this.$refs.labelDetailDialog) {
          const importTab = this.$refs.labelDetailDialog.$refs.importTab
          if (importTab && typeof importTab.loadData === 'function') {
            console.log('正在刷新导入标签页数据...')
            importTab.loadData()
            console.log('导入标签页数据刷新完成')
          } else {
            console.log('导入标签页不可用或loadData方法不存在')
          }
        } else {
          console.log('查看弹窗未打开或标签详情对话框不可用')
        }
      })
    },
    
    // 刷新迁移标签页数据
    refreshMigrateTabData() {
      // 延迟执行，确保DOM更新完成
      this.$nextTick(() => {
        if (this.viewDialogVisible && this.$refs.labelDetailDialog) {
          const migrateTab = this.$refs.labelDetailDialog.$refs.migrateTab
          if (migrateTab && typeof migrateTab.loadData === 'function') {
            console.log('正在刷新迁移标签页数据...')
            migrateTab.loadData()
            console.log('迁移标签页数据刷新完成')
          } else {
            console.log('迁移标签页不可用或loadData方法不存在')
          }
        } else {
          console.log('查看弹窗未打开或标签详情对话框不可用')
        }
      })
    },
    // 切换 Tab
    async switchTab(tabIndex) {
      this.activeTab = tabIndex
      // 切换标签页时清除选中状态
      this.selectedItemId = null
      await this.callWaveformList(tabIndex)
      
      // 平滑滚动到选中的菜单项
      this.$nextTick(() => {
        this.scrollToActiveMenuItem()
      })
    },
    async callWaveformList(tabIndex, page = 1, size = 20) {
      if (!this.tabList[tabIndex]) return
      
      const item = this.tabList[tabIndex]
      const params = {
        page: page,
        size: size,
        dictItemId: item.id
      }
      
      this.loading = true
      try {
        const response = await waveformList(params)
        console.log('waveformList 接口返回数据:', response.data)
        this.$set(this.gridData, tabIndex, response.data.records || [])
        this.$set(this.pageData, tabIndex, {
          current: response.data.current || page,
          size: response.data.size || size,
          total: response.data.total || 0,
          pages: response.data.pages || 0
        })
      } catch (error) {
        console.error('调用 waveformList 接口失败:', error)
      } finally {
        this.loading = false
      }
    },
    selectItem(itemId) {
      // 如果点击的是已选中的项目，则取消选中
      if (this.selectedItemId === itemId) {
        this.selectedItemId = null
      } else {
        this.selectedItemId = itemId
      }
    },
    // 分页大小改变事件
    handleSizeChange(size) {
      this.callWaveformList(this.activeTab, 1, size)
    },
    // 当前页改变事件
    handleCurrentChange(page) {
      const currentPageData = this.currentPageData
      this.callWaveformList(this.activeTab, page, currentPageData.size)
    },
    // 判断文字是否溢出
    isTextOverflow(text) {
      // 简单判断：如果文字长度超过10个字符，认为需要显示tooltip
      return text && text.length > 10;
    },
    
    // 平滑滚动到选中的菜单项
    scrollToActiveMenuItem() {
      // 等待DOM更新完成
      this.$nextTick(() => {
        const menuContainer = document.querySelector('.side-menu')
        const activeMenuItem = document.querySelector('.side-menu .el-menu-item.is-active')
        
        if (menuContainer && activeMenuItem) {
          const containerHeight = menuContainer.clientHeight
          const itemOffsetTop = activeMenuItem.offsetTop
          const itemHeight = activeMenuItem.clientHeight
          
          // 计算目标滚动位置：使选中项位于容器中上部
          const targetScrollTop = itemOffsetTop - (containerHeight / 2) + (itemHeight / 2)
          
          // 使用平滑滚动，支持自定义时间（800ms）
          this.smoothScrollTo(menuContainer, targetScrollTop, 800)
        }
      })
    },
    
    // 自定义平滑滚动函数
    smoothScrollTo(element, target, duration = 800) {
      const start = element.scrollTop
      const change = target - start
      const startTime = performance.now()
      
      // 如果滚动距离很小，使用更短的持续时间
      const actualDuration = Math.abs(change) < 100 ? 400 : duration
      
      // 使用更高级的缓动函数实现更自然的滚动效果
      const easeOutQuart = (t, b, c, d) => {
        t /= d
        t--
        return -c * (t * t * t * t - 1) + b
      }
      
      const animateScroll = (currentTime) => {
        const elapsed = currentTime - startTime
        const progress = Math.min(elapsed / actualDuration, 1)
        
        // 应用缓动函数
        const newPosition = easeOutQuart(progress, start, change, 1)
        element.scrollTop = newPosition
        
        if (progress < 1) {
          requestAnimationFrame(animateScroll)
        }
      }
      
      requestAnimationFrame(animateScroll)
    },
    // 获取当前选中的项目数据
    getSelectedItemData() {
      if (!this.selectedItemId) return null
      const currentData = this.currentGridData
      return currentData.find(item => item.id === this.selectedItemId) || null
    },
    // 获取当前标签页的数据
    getCurrentTabItemData() {
      const currentTab = this.tabList[parseInt(this.activeTab)]
      return currentTab || null
    },
    // 新增标签
    addLabel() {
      // 获取当前选中的左侧菜单项
      const currentTab = this.tabList[this.activeTab]
      if (!currentTab) {
        this.$message({
          message: '请先选择一个分类',
          type: 'warning'
        })
        return
      }
      // 设置表单数据，包括左侧菜单项的数据
      this.formLabelAlign = {
        dictItemId: currentTab.id, // 左侧菜单栏item.dictId
        dictItemName: currentTab.name.split('(')[0].trim(), // item.itemName (去掉括号部分)
        tagName: ''
      }
      this.dialogTitle = '新增标签'
      this.dialogFormVisible = true
    },
    // 修改标签
    async editLabel() {
      if (!this.selectedItemId) {
        this.$message({
          message: '请先选择一个标签',
          type: 'warning'
        })
        return
      }
      
      try {
        // 调用详情接口获取当前选中的标签数据
        const response = await waveformView(this.selectedItemId)
        if (response.code === 200 && response.data) {
          const tagData = response.data
          this.formLabelAlign = {
            dictItemId: tagData.dictItemId,
            dictItemName: tagData.dictItemName,
            tagName: tagData.tagName
          }
          this.dialogTitle = '修改标签'
          this.dialogFormVisible = true
        } else {
          this.$message({
            message: '获取标签详情失败',
            type: 'error'
          })
        }
      } catch (error) {
        console.error('获取标签详情失败:', error)
        this.$message({
          message: '获取标签详情失败',
          type: 'error'
        })
      }
    },
    // 删除标签
    async deleteLabel() {
      if (!this.selectedItemId) {
        this.$message({
          message: '请先选择一个标签',
          type: 'warning'
        })
        return
      }
      
      try {
        await this.$confirm('确定要删除选中的标签吗？此操作不可恢复。', '删除确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const res = await waveformDelete(this.selectedItemId)
        
        if (res.code === 200) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          
          // 保持当前选中状态，只刷新当前标签页的数据
          const currentTabIndex = this.activeTab
          const currentPage = this.currentPageData.current
          const currentSize = this.currentPageData.size
          
          // 刷新当前标签页的数据，保持分页状态
          await this.callWaveformList(currentTabIndex, currentPage, currentSize)
          
          // 可选：刷新标签列表（但不改变选中状态）
          await this.refreshTabList()
          
          // 清除选中状态
          this.selectedItemId = null
        }
      } catch (error) {
        if (error === 'cancel') {
          return
        }
        console.error('删除失败:', error)
        this.$message({
          message: '删除失败',
          type: 'error'
        })
      }
    },
    // 查看标签详情
    async viewLabel() {
      if (!this.selectedItemId) {
        this.$message({
          message: '请先选择一个标签',
          type: 'warning'
        })
        return
      }
      
      this.viewDialogVisible = true
    },
    
    // 处理导出按钮点击
    handleExport() {
      this.exportDialogVisible = true
    },
    
    // 导出分页大小改变
    handleExportSizeChange(size) {
      this.handleSizeChange(size)
    },
    
    // 导出当前页改变
    handleExportPageChange(page) {
      this.handleCurrentChange(page)
    },
    
    // 批量导出
    handleBatchExport(selectedRows) {
      console.log('批量导出选中的数据:', selectedRows)
    },
    
    // 跳转到任务中心
    handleJumpToTaskCenter() {
      this.$root.eventHub.$emit('openTaskCenter')
    },
    
    // 处理波形弹框关闭
    handleWaveClose() {
      this.waveDialogVisible = false;
      this.currentWaveId = '';
    },
    
    // 批量迁移标签
    handleBatchMigrate(recordIds, activeTab) {
      this.migrateRecordIds = recordIds;
      this.migrateDialogVisible = true;
      // 保存当前激活的标签页信息，用于设置operationType
      this.currentActiveTab = activeTab;
    },
    
    // 单个迁移标签
    handleMigrate(recordIds, activeTab) {
      this.migrateRecordIds = recordIds;
      this.migrateDialogVisible = true;
      // 保存当前激活的标签页信息，用于设置operationType
      this.currentActiveTab = activeTab;
    },

    // 查看波形
    handleViewWave(waveId) {
      this.currentWaveId = waveId;
      this.waveDialogVisible = true;
    },
    
    // 关闭迁移标签弹窗
    handleMigrateClose() {
      this.migrateDialogVisible = false;
      this.migrateRecordIds = [];
    },
    
    // 提交迁移标签
    async handleMigrateSubmit() {
      this.migrateDialogVisible = false; // 关闭迁移标签弹窗
      
      // 根据当前激活的标签页刷新对应的数据
      if (this.currentActiveTab === 'import') {
        // NPY文件上传数据标签页：刷新导入标签页数据
        setTimeout(() => {
          this.refreshImportTabData();
        }, 500);
      } else {
        // 关联网关数据标签页：刷新迁移标签页数据
        setTimeout(() => {
          this.refreshMigrateTabData();
        }, 500);
      }
      
      // 刷新主内容区域数据
      await this.callWaveformList(this.activeTab);
      // 刷新标签列表（保持当前选中状态）
      await this.refreshTabList();
      this.migrateRecordIds = [];
    },
    
    // 处理上传按钮点击
    handleUpload() {
      if (!this.selectedItemId) {
        this.$message({
          message: '请先选择一个标签',
          type: 'warning'
        })
        return
      }
      
      // 重置表单数据
      this.uploadFormData = {
        samplePoint: '256',
        sampleNum: '6'
      }
      
      // 重置文件列表
      this.fileList = []
      this.uploadDialogVisible = true
    },
    
    // 处理上传弹窗关闭
    handleUploadDialogClose() {
      // 清空文件列表
      if (this.$refs.fileUpload) {
        this.$refs.fileUpload.clearFiles()
      }
      
      // 清理进度条
      if (this.uploadProgressTimer) {
        clearInterval(this.uploadProgressTimer)
        this.uploadProgressTimer = null
      }
      this.uploadProgressVisible = false
      this.uploadProgress = 0
      
      // 其他清理工作
      this.uploadDialogVisible = false
      
      // 延迟刷新数据，确保服务器处理完成
      setTimeout(() => {
        this.refreshAllData()
      }, 500)
    },

    // 处理标签详情弹窗关闭
    handleLabelDetailDialogClose() {
      // 延迟刷新数据，确保服务器处理完成
      setTimeout(() => {
        this.refreshAllData()
      }, 500)
    },
    
    // 处理上传提交
    async handleUploadSubmit() {
      // 验证是否选择了文件
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.warning('请选择要上传的文件')
        return
      }
      
      // 结束上传批次，之后删除文件时总数会动态变化
      if (this.$refs.fileUpload) {
        const fileUploadRef = Array.isArray(this.$refs.fileUpload) ? this.$refs.fileUpload[0] : this.$refs.fileUpload
        if (fileUploadRef && typeof fileUploadRef.endBatch === 'function') {
          fileUploadRef.endBatch()
        }
      }
      
      // 开始进度条动画
      this.startUploadProgress()
      
      try {
        this.uploadLoading = true
        
        // 获取格式化的文件列表对象
        const formattedList = this.getFormattedFileList()
        
        // 获取当前左侧菜单栏目的ID
        const currentTabItem = this.tabList[parseInt(this.activeTab)]
        const dictItemId = currentTabItem ? currentTabItem.id : ''
        
        // 获取当前选中的项目数据
        const selectedItemData = this.getSelectedItemData()
        const currentTabItemData = this.getCurrentTabItemData()
        
        // 获取itemName和tagName
        const dictItemName = currentTabItemData ? currentTabItemData.name.split('(')[0].trim() : ''
        const waveformTagName = selectedItemData ? selectedItemData.tagName : ''
        
        // 构建上传参数
        const uploadParams = {
          dictItemId: dictItemId,  // 字典子项id（左侧菜单栏目ID）
          waveformTagId: this.selectedItemId,  // 波形标签id（右侧选中的项目ID）
          samplePoint: this.uploadFormData.samplePoint,  // 采样点
          cycleCount: this.uploadFormData.sampleNum,  // 周波数（对应cycleCount）
          npyMap: formattedList,  // 格式化的文件映射对象
          dictItemName: dictItemName,
          waveformTagName: waveformTagName
        }
        
        console.log('上传参数:', uploadParams)
        
        // 调用waveformNpyResolve接口
        const response = await waveformNpyResolve(uploadParams)
        
        if (response.code === 200) {
          // 停止进度条动画（成功）
          this.stopUploadProgress()
          
          this.$message({
            message: `成功上传并处理 ${this.fileList.length} 个文件`,
            type: 'success'
          })
          
          // 清空文件列表
          this.fileList = []
          this.uploadDialogVisible = false
          
          // 完全刷新所有数据（左侧菜单 + 右侧内容 + 弹窗数据）
          this.refreshAllData()
        } else {
          // 停止进度条动画（失败）
          this.stopUploadProgress()
          // 失败时也需要关闭弹框
          this.uploadDialogVisible = false
        }
        
      } catch (error) {
        console.error('上传处理失败:', error)
        this.$message.error('上传处理失败')
        // 停止进度条动画（错误）
        this.stopUploadProgress()
        // 错误时也需要关闭弹框
        this.uploadDialogVisible = false
      } finally {
        this.uploadLoading = false
      }
    },
    
    handleRemove(file, fileList) {
      console.log('移除文件:', file, fileList)
      this.fileList = fileList
    },
    
    beforeRemove(file) {
      return true
    },
    
    handleExceed(files, fileList) {
      this.$message.warning(`最多只能上传20个文件，当前已选择 ${fileList.length} 个文件`)
    },
    
    // 文件上传成功处理
    handleUploadSuccess(result) {
      // 这里可以处理上传成功后的逻辑
      console.log('文件上传成功:', result)
    },
    
    // 文件上传失败处理
    handleUploadError(error, file) {
      console.error('文件上传失败:', error)
      this.$message.error('文件上传失败')
      
      // 如果有失败的文件信息，更新文件状态为失败
      if (file && file.name) {
        const failedFileIndex = this.fileList.findIndex(f => f.name === file.name)
        if (failedFileIndex !== -1) {
          this.$set(this.fileList, failedFileIndex, {
            ...this.fileList[failedFileIndex],
            status: 'fail'
          })
        }
      }
    },
    
    // 文件上传加载状态处理
    handleUploadLoading(loading) {
      if (loading) {
        this.uploadingFileCount++
        this.uploadLoading = true
      } else {
        this.uploadingFileCount--
        if (this.uploadingFileCount <= 0) {
          this.uploadingFileCount = 0
          this.uploadLoading = false
        }
      }
    },
    
    // 开始进度条动画
    startUploadProgress() {
      this.uploadProgressVisible = true
      this.uploadProgress = 0
      
      // 每1秒增加随机值（小于10），直到接口有响应
      this.uploadProgressTimer = setInterval(() => {
        if (this.uploadProgress < 99) { // 最多到99%，等待接口响应后跳到100%
          // 添加随机值小于10
          this.uploadProgress += Math.random() * 10
          // 确保不超过99%
          this.uploadProgress = Math.min(this.uploadProgress, 99)
        }
      }, 1000)
    },
    
    // 停止进度条动画
    stopUploadProgress() {
      if (this.uploadProgressTimer) {
        clearInterval(this.uploadProgressTimer)
        this.uploadProgressTimer = null
      }
      
      // 接口响应后立即跳到100%
      this.uploadProgress = 100
      
      // 延迟隐藏进度条，让用户看到100%的状态，并添加完成效果
      setTimeout(() => {
        this.uploadProgressVisible = false
        this.uploadProgress = 0
      }, 800) // 稍微延长显示时间，让用户感受到完成
    },
    
    // 获取格式化后的文件列表对象
    getFormattedFileList() {
      const fileObj = {}
      this.fileList.forEach(file => {
        if (file.status === 'success' && file.url) {
          fileObj[file.name] = file.url
        }
      })
      return fileObj
    },
    
    // 提交表单
    submitForm() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const submitData = { ...this.formLabelAlign }
          
          try {
            let res
            if (this.dialogTitle === '修改标签') {
              submitData.id = this.selectedItemId
              res = await waveformUpdate(submitData)
            } else {
              res = await waveformAdd(submitData)
            }
            
            if (res.code === 200) {
              this.dialogFormVisible = false
              this.$message({
                message: this.dialogTitle === '修改标签' ? '修改成功' : '添加成功',
                type: 'success'
              })
              // 保持当前选中状态，只刷新当前标签页的数据
              const currentTabIndex = this.activeTab
              const currentPage = this.currentPageData.current
              const currentSize = this.currentPageData.size
              
              // 刷新当前标签页的数据，保持分页状态
              await this.callWaveformList(currentTabIndex, currentPage, currentSize)
              
              // 可选：刷新标签列表（但不改变选中状态）
              await this.refreshTabList()
              
              // 清除选中状态
              this.selectedItemId = null
            }
          } catch (error) {
            console.error('操作失败:', error)
            this.$message({
              message: this.dialogTitle === '修改标签' ? '修改失败' : '添加失败',
              type: 'error'
            })
          }
        } else {
          return false
        }
      })
    },
  }
}</script>

<style scoped>
/* 加载提示样式 */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-overlay .el-icon {
  font-size: 24px;
  margin-bottom: 10px;
  color: #139AA5;
}

.loading-overlay span {
  font-size: 14px;
  color: #606266;
}

.side-tab-wrapper {
  position: relative;
  display: flex;
  height: 100%;
  min-height: 500px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

/* 顶部按钮区域样式 - 公共右上角按钮区域 */
.top-btn-group {
  position: absolute;
  right: 25px;
  z-index: 10;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.95);
  padding: 12px 20px;
  border-radius: 12px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.top-btn-group .el-button {
  margin-left: 10px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.3s ease;
  min-width: 80px;
}

.top-btn-group .el-button--primary:hover,
.top-btn-group .el-button--primary:focus {
  background: linear-gradient(135deg, #4bb2bd 0%, #139AA5 100%);
  border-color: #4bb2bd;
  box-shadow: 0 4px 12px rgba(19, 154, 165, 0.4);
  transform: translateY(-2px);
}

.top-btn-group .el-button--primary:active {
  transform: translateY(0);
}

/* 普通按钮样式 */
.top-btn-group .el-button:not(.el-button--primary) {
  color: #606266;
  border-color: #e4e7ed;
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.top-btn-group .el-button:not(.el-button--primary):hover,
.top-btn-group .el-button:not(.el-button--primary):focus {
  color: #139AA5;
  border-color: #139AA5;
  background: #f8fdfd;
  box-shadow: 0 4px 10px rgba(19, 154, 165, 0.2);
  transform: translateY(-2px);
}

.top-btn-group .el-button:not(.el-button--primary):active {
  transform: translateY(0);
}

/* 禁用状态按钮样式 */
.top-btn-group .el-button.is-disabled {
  color: #c0c4cc;
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  box-shadow: none;
  cursor: not-allowed;
  opacity: 0.8;
}

.top-btn-group .el-button.is-disabled:hover {
  transform: none;
  box-shadow: none;
  color: #c0c4cc;
  background-color: #f5f7fa;
  border-color: #e4e7ed;
}

/* 侧边菜单容器 */
.side-menu-container {
  width: 250px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e4e7ed;
  background-color: #fafafa;
  height: 100%;
}

/* 搜索框容器 */
.menu-search-box {
  padding: 12px 16px;
  background-color: #fafafa;
  border-bottom: 1px solid #e4e7ed;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 10;
}

/* 搜索框样式 */
.menu-search-box .el-input__inner {
  border-radius: 20px;
  border: 1px solid #dcdfe6;
  background-color: #ffffff;
  transition: all 0.3s ease;
  font-size: 13px;
  height: 32px;
  line-height: 32px;
}

.menu-search-box .el-input__inner:focus {
  border-color: #139AA5;
  box-shadow: 0 0 0 2px rgba(19, 154, 165, 0.1);
}

.menu-search-box .el-input__inner:hover {
  border-color: #c0c4cc;
}

.menu-search-box .el-input__prefix {
  left: 10px;
}

.menu-search-box .el-input__icon {
  color: #909399;
  font-size: 14px;
}

.menu-search-box .el-input__clear {
  right: 10px;
  font-size: 14px;
}

/* 侧边菜单样式 */
.side-menu {
  flex: 1;
  border-right: none;
  box-sizing: border-box;
  background-color: #fafafa;
  overflow-y: auto;
  max-height: calc(100vh - 100px);
}

/* 滚动条美化 */
.side-menu::-webkit-scrollbar {
  width: 6px;
}

.side-menu::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.side-menu::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
  transition: background 0.3s ease;
}

.side-menu::-webkit-scrollbar-thumb:hover {
  background: #139AA5;
}

/* Firefox 滚动条样式 */
.side-menu {
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f1f1f1;
}

/* 自定义单选卡片样式 */
.custom-radio-group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.radio-card {
  min-width: 40px;
  padding: 8px 10px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.radio-card:hover {
  border-color: #00d8c3;
  background: #f8fdfd;
  box-shadow: 0 4px 12px rgba(19, 154, 165, 0.15);
}

.radio-card.active {
  border-color: #00d8c3;
  background: #00d8c3;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(19, 154, 165, 0.4);
}

.radio-number {
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
}

/* 侧边菜单项样式 */
.side-menu .el-menu-item {
  height: 48px;
  line-height: 48px;
  padding: 0 20px;
  color: #606266;
  font-size: 14px;
  transition: all 0.3s;
}

.side-menu .el-menu-item:hover {
  background-color: #e8f5f7;
}

/* 右侧内容面板样式 */
.content-panel {
  flex: 1;
  padding: 25px;
  box-sizing: border-box;
  background: #ffffff;
  margin-top: 60px; /* 为顶部按钮区域留出空间 */
  overflow-y: auto;
  position: relative;
  min-height: 400px;
}

/* 加载状态容器 */
.loading-container {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 100;
}

/* 加载动画样式 */
.loading-spinner {
  text-align: center;
  padding: 40px;
  background: #ffffff;
  border-radius: 12px;
}

.loading-spinner .el-icon-loading {
  font-size: 32px;
  color: #139AA5;
  margin-bottom: 16px;
  animation: rotating 1s linear infinite;
}

.loading-spinner p {
  color: #606266;
  font-size: 14px;
  margin: 0;
  font-weight: 400;
}

/* 无数据状态容器 */
.empty-container {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  z-index: 99;
}

/* 无数据内容样式 */
.empty-content {
  text-align: center;
  padding: 60px 40px;
  background: #ffffff;
  border-radius: 16px;
}

.empty-content .el-icon-document-delete {
  font-size: 64px;
  color: #dcdfe6;
  margin-bottom: 24px;
  opacity: 0.8;
}

.empty-content h3 {
  color: #303133;
  font-size: 18px;
  font-weight: 500;
  margin: 0 0 12px 0;
}

.empty-content p {
  color: #909399;
  font-size: 14px;
  margin: 0 0 24px 0;
  line-height: 1.5;
}

/* 查看弹框样式 */

.view-dialog-content .view-search-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 12px;
}

.view-dialog-content .view-button-group {
  margin-left: auto;
  flex: 1;
  display: flex;
  justify-content: flex-end;
  min-width: 200px;
}

.view-dialog-content .button-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
}

@media (max-width: 768px) {
  .view-dialog-content .view-button-group {
    width: 100%;
    margin-left: 0;
    margin-top: 8px;
  }
  
  .view-dialog-content .button-wrapper {
    justify-content: flex-start;
  }
}

.view-dialog-content .el-table {
  border-radius: 8px;
  overflow: hidden;
}

.view-dialog-content .el-table th {
  background-color: #fafafa !important;
  color: #606266;
  font-weight: 600;
  font-size: 14px;
  padding: 12px 0;
}

.view-dialog-content .el-table td {
  padding: 10px 0;
  font-size: 14px;
}

.view-dialog-content .el-button--text {
  font-size: 13px;
  padding: 0 8px;
  font-weight: 500;
}

.view-dialog-content .el-button--text:hover {
  transform: translateY(-1px);
  transition: all 0.3s ease;
}

.empty-content .el-button {
  margin-top: 8px;
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.empty-content .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(19, 154, 165, 0.3);
}

/* 加载动画关键帧 */
@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* 淡入动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 无数据图标动画 */
.empty-content .el-icon-document-delete {
  animation: fadeIn 0.6s ease-out;
}

.empty-content h3,
.empty-content p,
.empty-content .el-button {
  animation: fadeIn 0.8s ease-out;
}

.empty-content p {
  animation-delay: 0.1s;
}

.empty-content .el-button {
  animation-delay: 0.2s;
}

/* 宫格容器样式 */
.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 20px;
  margin-top: 15px;
  margin-bottom: 30px;
}

/* 分页容器样式 */
.pagination-container {
  margin-top: 20px;
  padding: 10px 0;
}

/* 宫格项目样式 - 现代卡片设计 */
.grid-item {
  border: 1px solid #ebeef5;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  background: #ffffff;
  min-height: 120px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  position: relative;
}

.grid-item:hover {
  box-shadow: 0 12px 32px rgba(19, 154, 165, 0.2);
  transform: translateY(-1px) scale(1.02);
  border-color: #00d8c3;
  background: linear-gradient(135deg, #ffffff 0%, #f8fdfd 100%);
}

/* 选中状态的宫格项目 - 高亮显示 */
.grid-item.selected {
  border-color: #00d8c3;
  background: linear-gradient(135deg, #e8f5f7 0%, #d6f0f3 100%);
  transform: translateY(-6px) scale(1.02);
  border-width: 1px;
}

/* 选中状态的装饰边框 - 渐变顶部装饰 */
.grid-item.selected::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 6px;
  background: linear-gradient(90deg, #139AA5 0%, #4bb2bd 50%, #67c23a 100%);
  border-radius: 0 0 6px 6px;
  box-shadow: 0 2px 8px rgba(19, 154, 165, 0.3);
}

/* 搜索高亮文本样式 */
.search-highlight-text {
  background-color: #ffeb3b;
  color: #303133;
  font-weight: 600;
  padding: 0 2px;
  border-radius: 2px;
  display: inline-block;
}

/* 搜索时菜单项的高亮样式 */
.custom-menu-item.search-highlight {
  background-color: #fff9c4;
  animation: highlight-pulse 1.5s ease-in-out;
}

@keyframes highlight-pulse {
  0%, 100% {
    background-color: #fff9c4;
  }
  50% {
    background-color: #fff59d;
  }
}

/* 无搜索结果提示样式 */
.no-search-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #909399;
  text-align: center;
}

.no-search-result i {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.5;
}

.no-search-result p {
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
}

/* 自定义菜单项样式 */
.custom-menu-item {
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  border-left: 3px solid transparent;
  transition: all 0.3s ease;
}

/* 菜单项内容容器 */
.menu-item-content {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  gap: 8px;
}

/* 菜单项代码样式 */
.menu-item-code {
  font-size: 11px;
  color: #909399;
  line-height: 1.2;
  font-family: 'Courier New', monospace;
  background-color: #f5f7fa;
  padding: 2px 6px 0px 6px;
  border-radius: 3px;
  border: 1px solid #e4e7ed;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

/* 分隔符样式 */
.menu-item-separator {
  color: #dcdfe6;
  font-size: 12px;
  margin: 0 2px;
}

/* 悬停效果 */
.custom-menu-item:hover .menu-item-code {
  background-color: #e8f4f8;
  border-color: #139AA5;
  color: #139AA5;
}

.custom-menu-item:hover .menu-item-separator {
  color: #139AA5;
}

/* 选中状态样式 */
.custom-menu-item.is-active .menu-item-code {
  background-color: #139AA5;
  border-color: #139AA5;
  color: #ffffff;
}

.custom-menu-item.is-active .menu-item-separator {
  color: #139AA5;
}

.custom-menu-item:hover {
  background-color: #f5f7fa;
}

.el-menu .custom-menu-item.is-active {
  background-color: #e8f5f7;
  border-left: 3px solid #139AA5;
  color: #139AA5;
  font-weight: bold;
}

.el-menu .custom-menu-item.is-active .el-tooltip {
  color: #139AA5;
  font-weight: bold;
}

/* 菜单项文字样式 - 文字过长时显示省略号 */
.menu-item-text {
  display: inline-block;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
  line-height: 1.4;
  font-weight: 500;
  flex-shrink: 0;
}

/* 宫格内容样式 - 现代卡片设计 */
.grid-content {
  padding-top: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  background: linear-gradient(135deg, #ffffff 0%, #f8fdfd 100%);
  border-radius: 12px;
  overflow: hidden;
  height: 100%;
}

.grid-item:hover .grid-content::before {
  opacity: 1;
}

.grid-content > * {
  position: relative;
  z-index: 1;
}

/* item-id 样式美化 - 靠左上角显示 */
.item-id {
  font-size: 12px;
  font-weight: 600;
  color: #909399;
  padding: 4px 4px;
  border-radius: 12px;
  margin-bottom: 8px;
  display: block;
  text-align: center;
  border: 1px solid #e4e7ed;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
}

/* 为标签内容添加更好的布局 */
.content-panel h3 {
  margin: 0 0 20px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #ebeef5;
  color: #303133;
  font-weight: 500;
  font-size: 16px;
}

/* 通用段落样式 */
.content-panel p {
  color: #606266;
  line-height: 1.6;
  margin: 0;
  font-size: 14px;
  font-weight: 400;
}

/* 宫格中的段落样式 */
.grid-content p {
  margin: 0;
  padding: 0;
  font-size: 15px;
  color: #303133;
  font-weight: 400;
  word-break: break-word;
  text-align: center;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

/* 统一内容项样式 - 现代卡片内容布局 */
.grid-content .content-item {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;
  padding: 8px 4px;
}

/* 内容项中的文字样式 - 优化字体层次 */
.grid-content .content-item div {
  font-size: 14px;
  line-height: 1.5;
  color: #606266;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

/* 标签名称样式 - 主标题突出 */
.grid-content .content-item div:first-child {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 6px;
  letter-spacing: 0.2px;
}

/* 悬停时的文字效果 - 优雅的交互反馈 */
.grid-item:hover .grid-content .content-item div:first-child {
  color: #139AA5;
  transform: translateY(-1px);
  text-shadow: 0 1px 2px rgba(19, 154, 165, 0.1);
}

.grid-item:hover .grid-content .content-item div:last-child {
  color: #4bb2bd;
  opacity: 1;
  transform: translateY(-1px);
}

/* 选中状态时的文字效果 - 高亮显示 */
.grid-item.selected .grid-content .content-item div:first-child {
  color: #139AA5;
  font-weight: 700;
  transform: translateY(-1px);
  text-shadow: 0 1px 3px rgba(19, 154, 165, 0.15);
}

.grid-item.selected .grid-content .content-item div:last-child {
  color: #139AA5;
  font-weight: 500;
  opacity: 1;
  transform: translateY(-1px);
}



/* 上传区域样式 */
.upload-section {
  width: 100%;
}

/* 上传进度条样式 */
.upload-progress-container {
  margin-top: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 6px;
  border: 1px solid #e4e7ed;
  animation: fadeIn 0.3s ease-in-out;
}

/* 上传遮罩层样式 */
.upload-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  border-radius: 4px;
  animation: fadeIn 0.3s ease-in-out;
}

.upload-overlay-content {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  min-width: 300px;
  text-align: center;
}

/* 上传对话框内容包装器 */
.upload-dialog-content-wrapper {
  position: relative;
  min-height: 200px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.upload-progress-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.progress-text {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

.progress-percent {
  font-size: 14px;
  color: #00d8c3;
  font-weight: bold;
  animation: pulse 1.5s ease-in-out infinite;
}

.success-icon {
  color: #67c23a;
  font-size: 16px;
  margin-right: 5px;
  animation: bounce 0.5s ease-in-out;
}

.loading-icon {
  color: #00d8c3;
  font-size: 16px;
  margin-right: 5px;
  animation: rotate 1s linear infinite;
}

.success-text {
  color: #67c23a;
  font-weight: bold;
}

@keyframes bounce {
  0%, 20%, 53%, 80%, 100% {
    transform: translate3d(0,0,0);
  }
  40%, 43% {
    transform: translate3d(0, -3px, 0);
  }
  70% {
    transform: translate3d(0, -2px, 0);
  }
  90% {
    transform: translate3d(0, -1px, 0);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}

/* 进度条动画效果 */
.upload-progress-container .el-progress-bar__outer {
  border-radius: 10px;
}

.upload-progress-container .el-progress-bar__inner {
  transition: width 0.5s ease-in-out;
  border-radius: 10px;
}
.el-button:disabled{
  opacity: 0.4;
}
</style>